<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form
        ref="addPersonnel"
        :rules="rules"
        :disabled="$route.query.type==='1'"
        :model="formData"
        label-width="120px"
        label-position="left"
        size="medium"
      >
        <p class="title">人员信息</p>
        <el-form-item label="人员姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入人员姓名"></el-input>
        </el-form-item>
        <p class="title">关联门店与角色</p>
        <div style="margin: 15px 0;">
          <el-input v-model="searchValue" placeholder="请输入门店关键字搜索" />
          <el-button type="primary" icon="el-icon-search" @click="filterList">搜索</el-button>
          <el-button type="primary" @click="resetList">重置</el-button>
        </div>

        <p>共{{total}}个门店，已选{{Object.keys(this.selection).length}}个门店</p>
        
        <el-table
          :data="storeList"
          border
          ref="storeList"
          @select="handleSelect"
          @select-all="handleSelectAll"
          @selection-change="handleSelectionChange"
          style="width:400px;"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="storeName" label="门店名称" align="center"></el-table-column>
          <el-table-column align="center">
            <template slot="header">
              门店角色
              <el-popover placement="top-start" title="角色说明" width="500" trigger="hover">
                <p>门店管理员：可登录商城APP进行下单等操作，可添加/删除门店人员</p>
                <p>门店人员：可登录商城APP进行下单等操作，不可添加/删除门店人员</p>
                <el-button style="border:none;" slot="reference" icon="el-icon-question" circle></el-button>
              </el-popover>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.roleId" @change="changeRoleId">
                <el-option label="门店管理员" :value="5"></el-option>
                <el-option label="门店人员" :value="1"></el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            style="float: left;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="formData.page"
            :page-size.sync="formData.size"
            :page-sizes="[20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total.sync="total"
            background
          ></el-pagination>
        </div>
        <p class="title" style="margin-top: 40px;">账号信息</p>
        <el-form-item prop="phone" label="绑定手机号">
          <el-input v-model="formData.phone" placeholder="请输入绑定手机号"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button size="mini" @click="$router.go(-1)">取消</el-button>
        <el-button type="primary" size="mini" @click="handleSubmit">保存</el-button>
      </div>
    </basic-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        phone: "",
        name: "",
        // code: "",
        storeIds: [],
        storeList: [],
        page: 1,
        size: 20,
      },
      total: 0,
      storeList: [],
      searchValue: "",
      storeListB: [],
      selection: {},
      rules: {
        phone: [{ required: true, message: "请绑定手机号" }],
        name: [{ required: true, message: "请输入人员姓名" }]
      }
    };
  },
  created() {
    this.formData.page = 1;
    this.getRelList();
  },
  methods: {
    async getRelList() {
      const { formData: { page, size }, searchValue: name } = this;
      const { ret, data: { list, total } } = await _api.store.getPageRelList({
        name,
        page,
        size
      });
      if (ret) {
        this.storeList = list.map(v => {
          return {
            storeId: v.storeId,
            storeName: v.storeName,
            roleId: 5,
            isEnable: v.isEnable
          };
        });
        this.total = total;
        this.washListBySelection();
        this.makeToggle();
      }
    },
    changeRoleId() {
      this.formData.storeList = this.$refs["storeList"].selection;
      this.formData.storeList.forEach(item => {
        if(this.selection[item.storeId.toString()]) this.selection[item.storeId.toString()] = item;
      })
    },
    handleSubmit() {
      this.$refs["addPersonnel"].validate(val => {
        if (val) {
          this.save();
        }
      });
    },
    handleSelectionChange(val) {
      this.formData.storeList = val;
    },
    async linkStroe(memberId) {
      var storeList = Object.keys(this.selection).map(val => {
        return this.selection[val]
      })
      const { ret, data } = await _api.member.addStore({
        memberId,
        storeList
      });
      if (ret && data) {
        this.$message({
          type: "success",
          message: "添加成功"
        });
      }
    },
    async save() {
      const { ret, data } = await _api.member.add(this.formData);
      if (ret && data) {
        const { result: memberId } = data;
        if (this.formData.storeList.length !== 0) {
          await this.linkStroe(memberId);
        }
        this.$router.go(-1);
      }
    },
    filterList() {
      this.formData.page = 1;
      this.getRelList();
    },
    makeToggle() {
      var keys= Object.keys(this.selection)
      var rows= this.storeList.filter((row)=> {
        return keys.includes(String(row.storeId))
      })
      this.$nextTick(()=> {
        rows.map(row=> {
          this.$refs["storeList"].toggleRowSelection(row);
        })
      })
    },
    // 保证选中的数据使用的之前修改但是未保存的数据
    washListBySelection() {
      let keys = Object.keys(this.selection);
      this.storeList = this.storeList.map(val=> {
        if(keys.indexOf(val.storeId.toString()) > -1) return this.selection[keys[keys.indexOf(val.storeId.toString())]]
        return val;
      })
    },
    handleSelect(selection, row) {
      if(this.selection[row.storeId]){
        // delete this.selection[row.storeId]
        this.$delete(this.selection, row.storeId)
      }else{
        // this.selection[row.storeId] = row
        if(!row.isEnable) {
          this.$message({
            type: "warning",
            message: "当前门店已达关联上限"
          })
          this.$nextTick(() => {
            this.$refs["storeList"].toggleRowSelection(row);
          })
          return ;
        }
        this.$set(this.selection, row.storeId, row)
      }
    },
    handleSelectAll(selection, row) {
      if(selection.length) {
        var temp = selection.filter(row => row.isEnable)
        if(selection.length !== temp.length){
          this.$message({
            type: "warning",
            message: "部分门店已达关联上限"
          })
        }
        this.$nextTick(()=> {
          this.$refs["storeList"].clearSelection();
          temp.map(row=> {
            this.$refs["storeList"].toggleRowSelection(row);
          })
        })
        temp.forEach(row => {
          // this.selection[row.storeId] = row
          this.$set(this.selection, row.storeId, row)
        })
      }else {
        Object.keys(this.selection).forEach(key=> {
          // delete this.selection[key]
          this.$delete(this.selection, key)
        })
      }
    },
    resetList() {
      this.searchValue = "";
      this.storeListB = JSON.parse(JSON.stringify(this.storeList));
      this.makeToggle()
    },
    handleSizeChange() {
      this.formData.page = 1;
      this.getRelList();
    },
    handleCurrentChange() {
      this.getRelList()
    }
  }
};
</script>
<style scoped>
.el-input {
  width: 300px;
}
.title {
  font-weight: 900;
  font-size: 18px;
}
</style>